import { sendGetRequest } from '@/services/api.service'
import { API_RADAR } from '@/config/api.config'

export const getAppUrl = async clientId => {
  const { data } = await sendGetRequest(`${API_RADAR.BASE_API_URL}${API_RADAR.APP}?clientId=${clientId}`)
  return data.results?.length > 0 ? data.results[0] : ''
}
